export enum ReportsFinanceRoutes {
    incomeExpenseGraph = "income-expense-graph",
    pLStatement = "profit-loss",
    balance = "balance",
}

export const ReportsFinanceNames = {
    pLStatement: "pLStatement",
    balance: "balance",
} as const;

export const ReportsFinanceReportNames = {
    pLStatement: "Profit & Loss Report",
    balance: "Balance Sheet Report",
} as const;

export const ReportsFinanceLabelName = {
    pLStatement: "Profit & Loss",
    balance: "Balance Sheet",
} as const;